import { render, staticRenderFns } from "./AddDosageForm.vue?vue&type=template&id=76022964&scoped=true"
import script from "./AddDosageForm.vue?vue&type=script&lang=js"
export * from "./AddDosageForm.vue?vue&type=script&lang=js"
import style0 from "./AddDosageForm.vue?vue&type=style&index=0&id=76022964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76022964",
  null
  
)

export default component.exports